const Privacy = () => {
  const formattedDate = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  return (
    <div className="min-h-screen bg-background p-8 pt-24">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
        <div className="prose dark:prose-invert">
          <p className="text-sm text-muted-foreground mb-8">Last updated: {formattedDate}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
            <p>
              Sentiri Ltd ("Sentiri Ltd," "we," "our," or "us") respects your privacy and is committed to protecting 
              your personal data. This Privacy Policy explains how we collect, use, and safeguard your information 
              when you sign up for our waitlist at Sentiri.io.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>Personal details: Name, email address, phone number (if provided) when you join our waitlist.</li>
              <li>Technical data: IP address, browser type, and usage activity on our website.</li>
              <li>Communication preferences and interactions with our emails or updates.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Legal Basis for Processing</h2>
            <p>We process your personal data based on the following lawful grounds:</p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Consent</strong>: When you provide your information to join the waitlist.</li>
              <li><strong>Legitimate Interest</strong>: To improve our website and communicate with you.</li>
              <li><strong>Legal Obligation</strong>: To comply with applicable laws and regulations.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. How We Use Your Information</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>To manage our waitlist and notify you about product launches, updates, and offers.</li>
              <li>To improve our website and services.</li>
              <li>To comply with legal and regulatory obligations.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Data Sharing and Third Parties</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>We do not sell or rent your personal data.</li>
              <li>We may share your data with third-party service providers who assist in email communication, hosting, and analytics, ensuring they comply with data protection laws.</li>
              <li>If required by law, we may share your data with regulators or law enforcement.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies to enhance your browsing experience. You can manage cookie preferences through your browser settings.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Data Retention</h2>
            <p>
              We will retain your data only for as long as necessary to fulfill the purposes outlined in this policy 
              or as required by law.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Your Rights Under GDPR</h2>
            <p>Under the General Data Protection Regulation (GDPR), you have the right to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Access, correct, or delete your personal data.</li>
              <li>Withdraw consent at any time.</li>
              <li>Request data portability.</li>
              <li>Restrict or object to data processing.</li>
              <li>Lodge a complaint with the Information Commissioner's Office (ICO) if you believe your data rights have been violated.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The latest version will always be available on our website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">10. Contact Information</h2>
            <p>
              For privacy-related inquiries, contact us at:{" "}
              <a href="mailto:enquiries@sentiri.io" className="text-[#00DC82] hover:underline">
                enquiries@sentiri.io
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;